<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>C2C订单审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane v-for="(type, key) in statusTypes" :key="key" :label="type.text" :name="key"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-input placeholder="请输入商户ID" clearable v-model="merchantUserId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <audit-list @refresh="getList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import AuditList from './components/list';
import { mapState, mapMutations, mapActions } from 'vuex';
import { STATUS_TYPE } from './constants.js';
export default {
  name: 'MerchantAudit',
  data() {
    return {
      merchantUserId: '',
      statusTypes: STATUS_TYPE
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('merchantAudit', [
      'activeTab',
      'pagination'
    ])
  },
  methods: {
    ...mapMutations('merchantAudit', ['changeTab']),
    ...mapActions('merchantAudit', [
      'list'
    ]),
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      this.list({
        merchantUserId: this.merchantUserId,
        status: this.activeTab === 'all' ? '' : this.activeTab,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.getList({
        page: 1
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less">
.user-withdrawal-link {
  color: #409eff;
  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.user-withdrawal-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }
  .user-withdrawal-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}
</style>
